var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"period-selector"},_vm._l((_vm.periodOptions),function(period){return _c('button',{key:period.value,staticClass:"period-btn",class:{ active: _vm.selectedPeriod === period.value },on:{"click":function($event){return _vm.onPeriodClick(period.value)}}},[_vm._v(" "+_vm._s(period.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }